<template>
  <div id="dashboard-analytics">
    <div class="vx-row">
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
        <statistics-card-line
          hideChart
          base-color="success"
          class="mb-base"
          icon="TruckIcon"
          icon-right
          color="white"
          :statistic="dashboardData['complete']"
          statisticTitle="Successfull booking this month"
        />
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
        <statistics-card-line
          hideChart
          class="mb-base"
          base-color="warning"
          icon="XCircleIcon"
          icon-right
          :statistic="dashboardData['cancelled']"
          statisticTitle="Cancelled booking in last 48h"
          color="white"
        />
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="AlertCircleIcon"
          icon-right
          statistic="TBA"
          statisticTitle="failed bookings last 48h "
          base-color="danger"
          color="white"
        />
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
        <statistics-card-line
          @click.native="$router.push('/venue/add')"
          hideChart
          class="mb-base cursor-hand"
          icon="PlusCircleIcon"
          icon-right
          statistic
          statisticTitle="Add Venue"
          base-color="dark"
          color="white"
        />
      </div>
    </div>

    <div class="vx-row mb-base">
      <div class="vx-col w-1/5">
        <div class="vx-col w-full">
          <statistics-card-line
            hideChart
            icon-right
            class="mb-base"
            icon="TruckIcon"
            statisticTitle="Average number of bookings"
            :statistic="dashboardData['averageBookings']"
            color="white"
            base-color="yellow"
          />
        </div>
        <div class="vx-col w-full">
          <statistics-card-line
            hideChart
            icon-right
            class="mb-base"
            icon="ClockIcon"
            statisticTitle="Average pickup time"
            :statistic="dashboardData['averagePickupTime'] + ' min'"
            color="white"
            base-color="primary"
          />
        </div>
        <div class="vx-col w-full">
          <statistics-card-line
            @click.native="statisticPopup = true"
            hideChart
            icon-right
            class="mb-base cursor-hand"
            icon="DownloadIcon"
            statisticTitle="Download advanced Excel statistics"
            statistic=""
            addHeight
            color="white"
            base-color="green"
          />
        </div>
        <div class="vx-col w-full" @click="graphPopup = true">
          <vx-card>
            <vue-apex-charts
              type="bar"
              height="215"
              :options="columnChart.chartOptions"
              :series="columnChart.series"
            ></vue-apex-charts>
          </vx-card>
        </div>
      </div>

      <div class="vx-col w-3/5 px-2 h-13">
        <div class="vx-col inline-flex w-full">
          <venue-google-map
            height="39rem"
            :markers="dashboardData['venuesMarker']"
          ></venue-google-map>
        </div>
      </div>

      <div class="vx-col w-1/5 px-2">
        <div class="vx-col w-full mb-base">
          <vx-card class="overflow-hidden p-3">
            <template slot="no-body">
              <vs-tabs vs-position="left" alignment="fixed">
                <vs-tab label="TAXIPOINT ONLINE">
                  <div class="mt-1 pl-2 ml-3">
                    <p class="mb-2">
                      <feather-icon
                        icon="CircleIcon"
                        :svgClasses="['fill-current h-4 w-4', 'text-success']"
                      />
                      {{ onlineUsers }} Online
                    </p>
                    <p class="mb-2">
                      <feather-icon
                        icon="CircleIcon"
                        :svgClasses="['fill-current h-4 w-4', 'text-warning']"
                      />
                      {{ onlineUsers }} Recent Online
                    </p>
                    <p class="mb-2">
                      <feather-icon
                        icon="CircleIcon"
                        :svgClasses="['fill-current h-4 w-4', 'text-grey']"
                      />
                      {{ offlineUsers }} Offline
                    </p>
                  </div>
                </vs-tab>
              </vs-tabs>
            </template>
          </vx-card>
        </div>

        <div class="vx-col w-full mb-base">
          <vx-card class="overflow-hidden p-5 h-15">
            <template slot="no-body">
              <vs-tabs vs-position="left" alignment="fixed">
                <vs-tab label="HIGHEST PERFORMING VENUES">
                  <div class="mt-1 pl-2">
                    <p
                      class="flex justify-between items-center"
                      v-for="(v, i) in dashboardData['highestPerformingVenues']"
                      :key="i + 'higest'"
                    >
                      {{ v.name }}
                      <span>{{ v.bookings_count }}</span>
                    </p>
                  </div>
                </vs-tab>
              </vs-tabs>
            </template>
          </vx-card>
        </div>
        <div class="vx-col w-full">
          <vx-card class="overflow-hidden p-5 h-15">
            <template slot="no-body">
              <vs-tabs vs-position="left" alignment="fixed">
                <vs-tab label="LOWEST PERFORMING VENUES">
                  <div class="mt-1 pl-2">
                    <p
                      class="flex justify-between"
                      v-for="(v, i) in dashboardData['lowestPerformingVenues']"
                      :key="i + 'lowest'"
                    >
                      {{ v.name }}
                      <span>{{ v.bookings_count }}</span>
                    </p>
                  </div>
                </vs-tab>
              </vs-tabs>
            </template>
          </vx-card>
        </div>
      </div>
    </div>

    <vs-popup title="Graphical Representation" :active.sync="graphPopup">
      <vx-card>
        <vue-apex-charts
          type="bar"
          height="315"
          :options="columnChart.chartOptions"
          :series="columnChart.series"
        ></vue-apex-charts>
      </vx-card>
    </vs-popup>
    <vs-prompt @cancel="clearFields"  :is-valid="validForm" title="Advanced Statistics" :active.sync="statisticPopup" :acceptText="'Download'" @accept="downloadExcel">
      <div class="con-exemple-prompt">
        <p class="mb-4 text-sm leading-none font-medium oneandhalf">
          Generate an overview of your bookingsfor a timeframe of your choice.
          Your options include: Hourly(maximum timeframe of 3 days),
          Daily(maximum timeframe of 62 days), Monthly(maximum timeframe of 1
          year)
        </p>

        <label class="text-sm font-bold ml-1">Interval*</label>

        <vs-select
          autocomplete
          class="w-full mb-4"
          v-model="time_interval"
        >
          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in time_interval_options"
          />
        </vs-select>

        <label class="text-sm font-bold ml-1">Start date: *</label>
        <datepicker
          name="start-date"
          class="mb-4"
          label="Name"
          placeholder="From Date"
          v-model="startDate"
          :disabledDates="disabledDatesFrom"


          >
        </datepicker>
        <label class="text-sm font-bold ml-1">End date: *</label>
        <datepicker
          :calendar-button="true"
          :bootstrap-styling="true"
          icon-pack="fa"
          val-icon-pack="fa"
          calendar-button-icon="eye"
          :disabledDates="disabledDatesTo"
          name="end-date"
          class="mb-4"
          label="Name"

          placeholder="To Date"
          v-model="endDate"
          icon-after="true"
          :disabled="!startDate"
        >
        </datepicker>
        <label class="text-sm font-bold m-4rem">Email: </label>
        <vs-input placeholder="email@email.com" class="w-full cust-rem" icon="mail" v-model="email" icon-after="true"/>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import VenueGoogleMap from "../views/charts-and-maps/maps/google-map/VenueGoogleMap";
import { _dashboard_record, _advance_statistics } from "@/services/Company";
import { _update_user_status } from "@/services/User";

import Datepicker from "vuejs-datepicker";
import moment from "moment";
import FeatherIcon from "../components/FeatherIcon.vue";
Date.prototype.addDays = function(days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}

const themeColors = ["#28C76F", "#ffc085", "#EA5455"];
export default {
  data() {
    return {
      time_interval_options: [
        { text: "Hourly", value: 1 },
        { text: "Daily", value: 2 },
        { text: "Monthly", value: 3 },
      ],
      time_interval: 1,
      columnChart: {
        series: [],
        chartOptions: {
          colors: themeColors,
          plotOptions: {
            bar: {
              horizontal: false,
              endingShape: "rounded",
              columnWidth: "55%",
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            show: true,
            width: 2,
            colors: ["transparent"],
          },

          xaxis: {
            categories: [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec",
            ],
          },
          yaxis: {
            title: {
              text: "number of bookings",
            },
          },
          fill: {
            opacity: 1,
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val + " bookings";
              },
            },
          },
        },
      },

      companyId: this.$store.state.company.companyID,
      dashboardData: {
        complete: "...",
        cancelled: "...",
        venuesMarker: [],
        dispatchedBookings: [],
        highestPerformingVenues: [],
        lowestPerformingVenues: [],
        averageBookings: "...",
        averagePickupTime: "...",
      },

      user: this.$store.state.AppActiveUser,
      count: 0,
      onlineUsers: 0,
      offlineUsers: 0,
      totalUsers: this.$store.state.company.total_users,

      graphPopup: false,
      statisticPopup: false,
      startDate: '',
      endDate: '',
      email: ''

    };
  },
  components: {
    VueApexCharts,
    StatisticsCardLine,
    VenueGoogleMap,
    Datepicker,
    FeatherIcon,
  },
  watch: {
    "$store.state.company.companyID"(val, oldVal) {
      this.getDashboardRecord(val);
      this.companyId = val;
      if (oldVal) this.leaveCommonRoom(oldVal);
      this.totalUsers = this.$store.state.company.total_users;
      this.columnChart["series"] = [];
      this.joinCommonRoom(val);
      // this.listen();
    },
    time_interval() {
      this.endDate = ''
    },
    startDate() {
      this.endDate = ''
    }
  },
  mounted() {
    let user_token = localStorage.getItem("accessToken");
    this.$echo.connector.options.auth.headers["Authorization"] =
      "Bearer " + user_token;

    this.getDashboardRecord(this.companyId);
    this.joinCommonRoom(this.companyId);
  },
  destroyed() {
    this.leaveCommonRoom(this.companyId);
  },
  computed: {
    validForm() {
        return this.startDate != '' && this.endDate != '' && (Date.parse(this.endDate) - Date.parse(this.startDate)) >= 0 && !this.errors.has('event-url');
    },
    disabledDatesTo() {
      let count = 0
      switch (this.time_interval) {
        case 1:
           count = 2;
          break;
        case 2:
            count = 61;
            break;
        case 3:
            count = 364;
            break;
       }
        let date  = new Date(this.startDate)

        return { to: date, from:  date.addDays(count) }
    },
    disabledDatesFrom() {
        return { from: new Date(this.endDate) }
    },
  },
  methods: {
    joinCommonRoom(companyId) {
      this.$echo
        .join(`common-room-company.${companyId}`)
        .here((users) => {
          this.onlineUsers = users.length - 1;
          this.offlineUsers = this.totalUsers - this.onlineUsers;
        })
        .joining((user) => {
          this.onlineUsers++;
          this.offlineUsers--;
          _update_user_status(user.id, { status: "online" }).then((res) => {});
        })
        .leaving((user) => {
          console.log("leave");
          this.onlineUsers--;
          this.offlineUsers++;
          _update_user_status(user.id, { status: "offline" }).then((res) => {});
        });
    },

    leaveCommonRoom(companyId) {
      this.onlineUsers = 0;
      this.offlineUsers = 0;
      this.totalUsers = this.$store.state.company.total_users;
      this.users = [];
      this.$echo.leave(`common-room-company.${companyId}`);
    },
    getDashboardRecord(company) {
      this.$vs.loading();
      _dashboard_record(company)
        .then(
          (res) => {
            this.dashboardData = res.data.obj.data;
            this.columnChart["series"] = res.data.obj.data["graphData"];
            this.$vs.loading.close();
          },
          (err) => {
            console.log(err);
          }
        )
        .catch((err) => {
          console.log(err);
        });
    },

    downloadExcel() {
      this.$vs.loading();

      let df = moment(this.startDate).format('YYYY-MM-DD');
      let dt = moment(this.endDate).format('YYYY-MM-DD');
      const data = {
        from_date: df,
        to_date: dt
      };

      _advance_statistics(this.companyId, data).then((res) => {
        this.clearFields();
            import("@/vendor/Export2Excel").then((excel) => {
            this.$vs.loading.close();

            const list = res.data.obj.data;
            const headerVal = [
                  "N.",
                  "Device ID",
                  "Location Name",
                  "Company",
                  "Status",
                  "Last Seen",
                  "Completed",
                  "NoFare",
                  "Cancelled",
                  "Booked"
            ];
            const data = this.formatJson(headerVal, list);
            excel.export_json_to_excel({
              header: [
                  "N.",
                  "Device ID",
                  "Location Name",
                  "Company",
                  "Status",
                  "Last Seen",
                  "Completed",
                  "NoFare",
                  "Cancelled",
                  "Booked"
            ],
              data,
              filename: moment(),
              autoWidth: true,
              bookType: "xls",
            });

          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          if (j == "N.") return v.id;
          else if (j == "Device ID") return v.device_id;
          else if (j == "Location Name") return v.street;
          else if (j == "Company") return v.name;
          else if (j == "Status") return v.status;
          else if (j == "Last Seen") return v.last_active;
          else if (j == "Completed") return v.complete_count;
          else if (j == "NoFare") return v.nofare_count;
          else if (j == "Cancelled") return v.cancelled_count;
          else if (j == "Booked") return v.booked_count;
          else return v[j];
        })
      );
    },
    clearFields() {
        this.email = this.startDate = this.endDate  = "";
        this.time_interval = 1;



    },
  },
};
</script>

<style lang="scss">
.m-4rem {
  margin-left: 0.4rem;
}
.cust-rem {
  margin-left: 0.1rem;
}
.oneandhalf {
  line-height: 1.5rem !important;
}
/*! rtl:begin:ignore */
#dashboard-analytics {
  .h-13 {
    height: 13rem;
  }
  .h-15 {
    height: 15rem;
  }
  .h-full {
    height: 300px;
  }
  .ml-3 {
    margin-left: 3rem !important;
  }
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
  .cursor-hand {
    cursor: pointer;
  }
}
/*! rtl:end:ignore */
</style>
